// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"c017e058","479":"757a0cdc"}[chunkId] + ".chunk.js";
};